import { API_BASE_URL } from './constants';
import { axiosInstance } from './apiUtils';
import axios from 'axios';
import { obtenerError } from 'utils/utilities';
import { EliminarAlquiler } from 'utils/models/interfaces';

const eliminarAlquilerPath = `${API_BASE_URL}/Alquileres/`;

// Función genérica DELETE
export const deleteData = async <T>(
  url: string,
  data: unknown,
  setError: (message: string) => void,
  setLoading: (state: boolean) => void
): Promise<T | null> => {
  try {
    setLoading(true);
    const response = await axiosInstance.delete<T>(url, { data });
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar ${url}:`, error);
    if (axios.isAxiosError(error)) {
      await obtenerError(error, setError);
    } else {
      const errorGenerico = 'Error desconocido';
      setError(errorGenerico);
      console.error(errorGenerico, error);
    }
    return null; // Retorna null en caso de error
  } finally {
    setLoading(false);
  }
};

export const eliminarAlquiler = async (
  objetoEliminar: EliminarAlquiler,
  setError: (message: string) => void,
  setLoading: (state: boolean) => void
) => {
  const { IdAlquiler } = objetoEliminar;
  await deleteData(`${eliminarAlquilerPath}${IdAlquiler}`, objetoEliminar, setError, setLoading);
};
